var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaceWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.5,
    height: 46.5,
    viewBox: "0 0 46.5 46.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0 0.01)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M23.25,46.49A23.25,23.25,0,1,0,0,23.25,23.25,23.25,0,0,0,23.25,46.49",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M.006,10.19C-.146,6.038,2.85,2.215,7.62.473c7.222-2.554,18.934,5.843,18.443,10.691",
    transform: "translate(10.024 24.15) rotate(-2)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M17.19,16.88c.07-.08-.05-1.19.76-.06-1.73-.54-.17-.82.48-1.74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M17.19,16.88c.07-.08-.05-1.19.76-.06-1.73-.54-.17-.82.48-1.74",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M29.89,16.88c.07-.08-.05-1.19.76-.06-1.73-.54-.17-.82.48-1.74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M29.89,16.88c.07-.08-.05-1.19.76-.06-1.73-.54-.17-.82.48-1.74",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M24.63,2.7C7.65,1.08-5.8,23.17,9.24,38.53c19.51,19.92,50-11.2,26.34-32.79",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceWhite);
export default __webpack_public_path__ + "static/media/faceWhite.3c7a6fd8390b826d756ded089a466dae.svg";
export { ForwardRef as ReactComponent };